import { formatDateRange } from '@/utils';
import { Flex } from 'antd';
import dayjs from 'dayjs';
import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { PayrollLeakageDailyBreakdown } from '../../../../../../app/features/employee/management-dashboard/management-dashboard.type';

const CustomTooltip = (props: any) => {
  const { active, payload, label } = props;

  if (active && payload && payload.length) {
    return (
      <div className="bg-[#0F172A] text-white p-2 rounded border border-[#1f2d40] text-xs">
        <p className="text-center font-bold mb-1">
          {dayjs(label).format('MMM D')}
        </p>
        <p className="text-[#05AB42]">{payload[0].value.toFixed(1)} h</p>
      </div>
    );
  }

  return null;
};

const LostWorkHours = ({
  daily_breakdown,
  start_date,
  end_date,
}: {
  daily_breakdown?: PayrollLeakageDailyBreakdown[];
  start_date?: string;
  end_date?: string;
}) => {
  const chartData = (daily_breakdown || []).map((item) => ({
    name: item.date,
    value: item.total_lost_minutes / 60,
  }));

  return (
    <div className="bg-theme-slate-900 border border-theme-gray-700 p-4 rounded-xl w-full">
      <Flex justify="space-between" align="center" className="mb-6">
        <h4 className="text-lg px-3 py-1 rounded border border-theme-gray-700 text-white leading-tight">
          Lost Work Hours
          <span className="text-theme-primary block text-sm">
            {formatDateRange(start_date, end_date)}
          </span>
        </h4>
      </Flex>

      <ResponsiveContainer width="100%" height={250}>
        <AreaChart data={chartData}>
          <defs>
            <linearGradient id="colorLost" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#05AB42" stopOpacity={0.3} />
              <stop offset="95%" stopColor="#05AB42" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="#1e2a38"
            vertical={false}
          />
          <XAxis
            dataKey="name"
            stroke="#94a3b8"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 10 }}
            tickFormatter={(value) => dayjs(value).format('DD')}
          />
          <YAxis
            stroke="#94a3b8"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 10 }}
            tickFormatter={(value) => `${value.toFixed(0)}h`}
          />
          <Tooltip
            content={<CustomTooltip />}
            cursor={{ stroke: '#ffffff', strokeWidth: 1 }}
          />
          <Area
            type="monotone"
            dataKey="value"
            stroke="#05AB42"
            strokeWidth={2}
            fillOpacity={1}
            fill="url(#colorLost)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default LostWorkHours;
